/**
 * Who on this list has heard from us recently.
 *
 * A warning and never a block. There are perfectly good reasons to message
 * somebody twice in a week — a correction, a second branch, a genuinely
 * different offer — and a panel that refused would be worked around within a
 * day. What it can do is make the fact impossible to *miss* on the screen where
 * somebody is about to approve ten thousand messages.
 *
 * The list is only as long as the campaign, because the question is asked about
 * the numbers on the screen rather than answered out of the whole history.
 */

export interface Contact {
  readonly phone: string;
  readonly last_sent_at: string;
  readonly campaign_id: number;
}

export interface FatigueRow {
  readonly phone: string;
  readonly at: string;
  readonly campaignId: number;
}

export interface FatigueView {
  readonly count: number;
  /** Most recently contacted first: the freshest is the one worth arguing about. */
  readonly rows: readonly FatigueRow[];
  readonly days: number;
}

/**
 * How far back to look.
 *
 * A fortnight. Long enough to catch "we already ran this campaign", short
 * enough that a monthly promotion is not flagged against itself every time.
 */
export const FATIGUE_DAYS = 14;

export function fatigueView(contacts: readonly Contact[], days: number = FATIGUE_DAYS): FatigueView {
  const rows = contacts
    .map((contact) => ({ phone: contact.phone, at: contact.last_sent_at, campaignId: contact.campaign_id }))
    .sort((a, b) => b.at.localeCompare(a.at) || a.phone.localeCompare(b.phone));

  return { count: rows.length, rows, days };
}
